/**
 * Redux middlewares and interop with Flux.
 */
import createLogger from 'redux-logger'
import { queryString as qs } from '../utils/window'
import { queryString } from '../utils/window'
import { appDispatcher } from './AppDispatcher'
import thunk from 'redux-thunk'
import { applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import GtmService from '../organizedByType/services/GtmService'

import { composeWithDevTools } from 'redux-devtools-extension'

const FLUX_ACTION_SOURCE = Symbol('Flux action')
const reduxLoggerConf = {
  collapsed: true,
  duration: true,
  timestamp: true,
  colors: {
    title: action => {
      return action.source === FLUX_ACTION_SOURCE ? 'red' : 'green'
    },
  },
}

const FEATURE_FLAGS = {
  routeAllFluxActionsToRedux: qs.routeAllFluxActionsToRedux,
}

let gtmService = null

function getGtmService(...args) {
  return (gtmService || (gtmService = GtmService()))(...args)
}

function dispatchReduxAction(reduxStore, fluxAction) {
  if (FEATURE_FLAGS.routeAllFluxActionsToRedux || fluxAction.dispatchToRedux) {
    reduxStore.dispatch({
      type: fluxAction.type,
      source: FLUX_ACTION_SOURCE,
      state: fluxAction.payload,
    })
  }
}

function fluxConnectorMiddleware(store) {
  return next => action => {
    const result = next(action)
    if (action.source !== FLUX_ACTION_SOURCE && result) {
      appDispatcher.dispatchAction.view(result)
    }
    return result
  }
}

function fluxConnectorStoreEnhancer() {
  return next => (...args) => {
    const store = next(...args)
    appDispatcher.register(dispatchReduxAction.part(store))
    return store
  }
}

export const logger = queryString.debugRedux
  ? createLogger(reduxLoggerConf)
  : store => next => action => next(action)

export const gtmHandler = store => next => action => {
  getGtmService(action)

  next(action)
}

export function dynamicSagasMiddleware(reducerStateKeys, sagaKey, applicationSagas) {
  return store => next => action => {
    const state = store.getState()
    const stateChunksWithSagas = Object.keys(state).filter(key => reducerStateKeys.includes(key))
    if (!stateChunksWithSagas) {
      return next(action)
    }
    const sagasChunks = stateChunksWithSagas.reduce((accumulator, reducerName) => {
      if (store.getState()[reducerName][sagaKey]) {
        return [...accumulator, store.getState()[reducerName][sagaKey]]
      }
    }, [])

    if (!sagasChunks.length) {
      return next(action)
    }

    const sagasList = sagasChunks.reduce((accumulator, sagas) => {
      return [...accumulator, ...sagas]
    }, [])
    if (!sagasList) {
      return next(action)
    }
    return createSagaMiddleware(...sagasList)(store)(next)(action)
  }
}

const storeMiddleware = applyMiddleware(
  dynamicSagasMiddleware(['mountedComponents'], 'sagas'),
  thunk,
  logger,
  gtmHandler,
  fluxConnectorMiddleware
)

export const commonConfiguration = [
  fluxConnectorStoreEnhancer(),
  composeWithDevTools(storeMiddleware),
]



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/reduxAppCore.js